module.exports = __webpack_public_path__ + "static/media/Combine Lead Generation@2x.cfb5b29d.png";